import {
  useMetricsStats,
  useMetricsTrends,
  useMetricsDistribution,
  useMetricsPatterns,
} from "../../../../../shared/hooks";
import type {
  MetricsStatsParams,
  MetricsTrendsParams,
  MetricsFilters,
  MetricsPatternsParams,
} from "../../../../../shared/api/types";

export const useOverallStressStats = (params?: MetricsStatsParams) => {
  return useMetricsStats({
    ...params,
    metrics: params?.metrics || ["stress_score", "high_stress_days"],
  });
};

export const useOverallStressTrends = (params?: MetricsTrendsParams) => {
  return useMetricsTrends({
    ...params,
    metrics: params?.metrics || ["stress_score", "stress_recovery_balance"],
    granularity: params?.granularity || "daily",
  });
};

export const useOverallStressDistribution = (params?: MetricsFilters) => {
  return useMetricsDistribution({
    ...params,
    metric: "stress_level_distribution",
  });
};

export const useOverallStressPatterns = (params: MetricsPatternsParams) => {
  return useMetricsPatterns({
    ...params,
    // The generic hook takes one metric, but the user listed two: stress_score_patterns and hrv_patterns.
    // The user of this hook will specify which metric to fetch.
  });
};
